export default {
	base: {
		modal: {
			ok: 'OK',
			cancel: 'Cancel'
		},
		install: {
			title: "Install IDICARE",
			message: "Install this application on your home screen for quick and easy access when you're on the go.",
			buttons: {
				later: 'Later',
				install: 'Install Now'
			}
		},
		idicare: {
			slogan_1: "Technologies d'aide à la santé",
			slogan_2: "Nous nous soucions de votre santé",
		},
		general: {
			dashboard: "Tableau de bord",
			// groups
			group: "Groupe",
			groups: "Groupes",
			// devices
			device: "Dispositif",
			devices: "Dispositifs",
			// patients
			patient: "Patient",
			patients: "Patients",
			no_patients: "Pas de patients",
			see_all_patients: "Voir tous les patients",
			next_appointment: "Prochain rendez-vous",
			next_birthday: "Prochain anniversaire",
			// alerts
			alerts: "Les alertes",
			no_alerts: "Aucune alerte",
			see_all_alerts: "Voir toutes les alertes",
			// user
			user_account: "Compte",
			// profile
			profile: "Profil",
			user_profile: "Profil de l'utilisateur",
			your_profile: "Votre profil",
			no_results: "Aucun résultat trouvé",
		},
		auth: {
			login: "S'identifier",
			logout: "Connectez - Out",
			signup: "S'inscrire",
			register: "Créer un compte",
			already_registered: "Vous n'avez pas encore de compte?",
			no_account: "Vous n'avez pas de compte?",
			forgot_password: "Mot de passe oublié?",

			or: "ou",
			you_are_logged_out: "Vous êtes déconnecté",
			account_activation: "Activation de compte",
			recover_password: "Récupérer mot de passe",
			request_new_password: "Demander un nouveau mot de passe",
			request: "Demande",
			confirm: "Confirmer",
			back: "Retour",
			msg_use_policy: "Je confirme avoir au moins 16 ans et j'accepte que IDICARE traite mes données personnelles dans le but d'envoyer des supports marketing personnalisés conformément au",
			msg_privacy_policy: "J'ai pu lire et comprendre les informations sur l'utilisation de mes données personnelles expliquées dans le"
		},
		account: {
			change_account: "Changer de compte",
			accounts: "Comptes",
		},
		watch: {
			biometric: "Biometric Data",
			geofencing: "Geo Fencing",
			current_location: "Localisation actuelle",
			pillbox: "Pill Box",
			medication: "Médicaments",
			no_medication_today: "Il n'y a pas de médicament pour aujourd'hui",
			appointments: "Rendez-vous",
			no_appointments_today: "Aucun rendez-vous pour aujourd'hui",
			healthreports: "Rapports de santé",
			medicaldocs: "Documents médicaux",
			profile: "Profil du patient",
			chat: "Chat",
			personal_information: "Informations personnelles",
			timeline: "Chronologie",
			no_events: "Aucun événement trouvé",
		},
		profile: {
			account_information: "Information sur le compte",
			payment_methods: "Méthodes de payement",
			current_plan: "Plan actuel",
			pro_plan: "PRO Plan",
			notifications: "Notifications",
			organizations: "Organisations",
			staff: "Personnel",
			synchronization: "Synchronisation",
			// account information
			information: "Information",
			change_name: "Changer de nom",
			change_email: "Changer l'e-mail",
			change_password: "Changer le mot de passe",
			change_picture: "Changer l'image",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/base/base_fr.js